import { connect } from 'react-redux';
import { HeaderWithMetrics } from '@zocdoc/components/src/Layout/Header';
import { UPDATE_PRIVACY_POLICY_BANNER_FLAG } from '@zocdoc/components/src/experiments';
import { withAB } from '../../config/ab';
import { trackConversion as trackSignInLinkClickConversion } from '../../config/ab/actions';
import { getWellGuideLinkVariant } from '../../config/ab/selector';
import { PINA_HAMBURGER_MENU_WELL_GUIDE_LINK } from '../../config/ab/experiments';

const mapDispatchToProps = { trackSignInLinkClickConversion };

const mapStateToProps = state => ({
    wellGuideLinkVariant: getWellGuideLinkVariant(state),
});

const AB_FLAGS = [
    UPDATE_PRIVACY_POLICY_BANNER_FLAG,
    PINA_HAMBURGER_MENU_WELL_GUIDE_LINK,
];

const headerWithAb = withAB(AB_FLAGS)(HeaderWithMetrics);

export default connect(mapStateToProps, mapDispatchToProps)(headerWithAb);
